export default () => {
  const sliderParents = document.querySelectorAll('.js-project-slider-parent');
  if (document.body.clientWidth < 1000) return;
  if (sliderParents.length < 1) return;

  [...sliderParents].forEach(sliderParent => {
    // Variables
    const slider = sliderParent.querySelector('.js-project-slider');
    const slide = sliderParent.querySelector('.js-project-slide');
    const filler = sliderParent.querySelector('.js-project-filler');
    const slides = sliderParent.querySelectorAll('.js-project-slide');
    const next = sliderParent.querySelector('.js-project-slider-next');
    const prev = sliderParent.querySelector('.js-project-slider-prev');

    if (slides.length < 1) return;
    let slided = 1;
    filler.style['min-width'] = `${slide.offsetWidth * 2}px`;
    filler.style['max-width'] = `${slide.offsetWidth * 2}px`;

    // Next function
    next.addEventListener('click', e => {
      slider.scrollTo({
        top: 0,
        left: slide.offsetWidth * slided - 1,
        behavior: 'smooth',
      });

      if (slided != slides.length) slided++;
      prev.classList.remove('inactive');

      if (slided == slides.length) next.classList.add('inactive');
    });

    // Prev function
    prev.addEventListener('click', e => {
      slider.scrollTo({
        top: 0,
        left: slide.offsetWidth * slided - slide.offsetWidth * 2,
        behavior: 'smooth',
      });

      if (slided != 1) slided--;
      next.classList.remove('inactive');
      if (slided == 1) prev.classList.add('inactive');
    });
  }); // end foreach
};



// WEBPACK FOOTER //
// ./src/js/modules/ProjectsSlider.js